export default __webpack_public_path__ + "static/media/Tamal.629d26af.jpg";